import { useIsMobile } from '../../../hook/useIsMobile';
import { UsedTicketModalPc } from './UsedTicketModal/UsedTicketModal.pc';
import { UsedTicketModalMobile } from './UsedTicketModal/UsedTicketModal.mobile';

export type UsedTicketModalProps = {
  isVisibleCommon: boolean;
  commonCallback1?: () => void;
  commonCallback2?: () => void;
};

export const UsedTicketModal = (props: UsedTicketModalProps) => {
  const isMobile = useIsMobile();
  return isMobile ? <UsedTicketModalMobile {...props} /> : <UsedTicketModalPc {...props} />;
};
